import { defineStore } from 'pinia'

export const useCookieStore = defineStore('cookie', () => {
    const tokenCookie = useCookie('GATEWAY')

    function currentToken() {
        return tokenCookie.value
    }

    function updateToken(t) {
        tokenCookie.value = t
    }

    return { currentToken, updateToken }
})
